import { AnimType } from '@tencent/slide-sdk-model';

// 动画的nodeTypes
export const nodeTypes = {
    NONE: 'none',
    CLICK_EFFECT: 'clickEffect',        // 单击动画
    WITH_EFFECT: 'withEffect',          // 同时执行动画
    AFTEREFFECT: 'afterEffect',         // 之后执行动画
};

export const PATH_ANIM_TYPES =  {
    ARC: AnimType.Arc,
    STRAIGHT_LINE: AnimType.StraightLine,
    CYCLE: AnimType.Cycle,
    SHAPE: AnimType.Shape,
    TURN: AnimType.Turn,
    CUSTOM: AnimType.Custom, // 路径动画除了五类基本类型动画，其余都处理为自定义路径动画
};

export const MEDIA_ANIM_TYPES = {
    PLAY: AnimType.Play,
    PAUSE: AnimType.Pause,
    STOP: AnimType.Stop,
};

// 动画的tnAnimTypes
export const tnAnimTypes = {
    NONE: 'none',
    TN_SET: 'tn_set',                       // 设置类动作
    TN_ANIM_EFFECT: 'tn_animEffect',         // 动画类型动作
    TN_ANIM_Scale: 'tn_animScale',           // 缩放类型
    TN_ANIM_Rotation: 'tn_animRot',
    TN_ANIM: 'tn_anim',
    TN_ANIM_MOTION: 'tn_animMotion',        // 路径动画类型
    TN_CMD: 'tn_cmd', // 媒体-命令类型
};


// 动画的animFillTypes
export const animFillTypes = {
    NONE: 'none',
    HOLD: 'hold',                       // 保持类动画
    REMOVE: 'remove',                   // 播放完回退类动画
};

// 动画的presetClassTypes
export const presetClassTypes = {
    NONE: 'none',
    ENTR: 'entr',                       // 进入
    EXIT: 'exit',                       // 退出
    EMPH: 'emph',                       // 增强
    PATH: 'path',                       // 路径
    MEDIA: 'mediacall',                 // 媒体类型
};

export const TimeIndefinite = 'STTLTimeIndefinite_indefinite';
